import { makeStyles } from '@material-ui/core/styles';
import { green, red, grey, yellow } from "@material-ui/core/colors";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        backgroundColor: "#DBBB44",
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
        height: 100 + "vh"
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    contentItem: {
        borderColor: grey[600],
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 8,
        padding: 16,
        marginTop: 24,
        backgroundColor: "#FFFFFF"
    },
    formControl: {
        width: 100 + '%',
        marginTop: 24
    },
    buttonSuccess: {
        background: green[600],
        color: theme.palette.getContrastText(green[600]),
        '&:hover': {
            background: `${green[700]} !important`,
        }
    },
    buttonDanger: {
        background: red[500],
        color: theme.palette.getContrastText(red[500]),
        '&:hover': {
            background: `${red[700]} !important`,
        }
    },
    buttonSecondary: {
        background: grey[600],
        color: theme.palette.getContrastText(grey[600]),
        '&:hover': {
            background: `${grey[700]} !important`,
        }
    },
    buttonWarning: {
        background: yellow[600],
        color: theme.palette.getContrastText(yellow[600]),
        '&:hover': {
            background: `${yellow[700]} !important`,
        }
    }
}));


export default useStyles